import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import { useFormikContext } from "formik";
import { FC } from "react";
import { typeOptions } from "./OssDropDownOptions";

interface SummaryProps {
    onBack: () => void;
}

const Summary: FC<SummaryProps> = ({ onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();
    const selectedType = translate.byKey(values.type === "0"  ? TranslationKeys.doorGroupId : TranslationKeys.doorId);
    
    return <div className='flex flex-col h-full px-2 py-1 relative space-y-1'>
        <span className={`text-portal-blue-primary-shade2 pb-3 text-xl font-semibold`} >
            {translate.byKey(TranslationKeys.summary)}
        </span>

        <div className="grid grid-cols-2 gap-2">
            <div className="flex flex-col space-y-2">
                <span className="text-xs text-gray-500">{translate.byKey(TranslationKeys.name)}</span>
                <span className="text-xs text-gray-500">{translate.byKey(TranslationKeys.type)}</span>
                <span className="text-xs text-gray-500">{selectedType}</span>
                <span className="text-xs text-gray-500">{translate.byKey(TranslationKeys.site)}</span>
            </div>
            <div className="flex flex-col space-y-2">
                <span className="text-xs">{values.name}</span>
                <span className="text-xs">{typeOptions.find(option => option.value === values.ossdType)?.label}</span>
                <span className="text-xs">{values.ossdDeviceId}</span>
                <span className="text-xs">{values.siteName}</span>
            </div>
        </div>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5"
                    type="button"
                    data-cy="backButton"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}
                </button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary bg-lime rounded-full text-white`}
                    data-cy="submitButton"
                    type="submit">
                    {translate.byKey(TranslationKeys.submit)}
                </button>
            </div>
        </div>
    </div>
}

export default Summary;